module.exports = __webpack_public_path__ + "static/media/icon4.c798d367.png";